import React from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";
import {IOfferListRoomsFilter} from "../list/helpers/location_generic_description/constants";
import {getOfferListDatasetSchema} from "../list/helpers/location_generic_description/get_offer_list_dataset_schema";
import {OfferType} from "../types/OfferType";

interface IProps {
    offerType: OfferType;
    filters?: IOfferListRoomsFilter | null;
    region: ISelectedRegion;
    updateDate?: string;
}

export const SchemaOfferListDataset = (props: IProps) => {
    const canonicalUrl = useSelector((state: IRPStore) => state.metaData.standardMetaData.canonical);

    const datasetSchema = getOfferListDatasetSchema({
        offerType: props.offerType,
        filters: props.filters,
        region: props.region,
        url: canonicalUrl,
        updateDate: props.updateDate
    });

    if (!datasetSchema) {
        return null;
    }

    // Escape "<" so a "</script>" sequence inside data-sourced text (e.g. region.name) can't break out of the tag.
    const json = JSON.stringify(datasetSchema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
import React from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";
import {IOfferListRoomsFilter} from "../list/helpers/location_generic_description/constants";
import {getOfferListDatasetSchema} from "../list/helpers/location_generic_description/get_offer_list_dataset_schema";
import {OfferType} from "../types/OfferType";

interface IProps {
    offerType: OfferType;
    filters?: IOfferListRoomsFilter | null;
    region: ISelectedRegion;
    updateDate?: string;
}

export const SchemaOfferListDataset = (props: IProps) => {
    const canonicalUrl = useSelector((state: IRPStore) => state.metaData.standardMetaData.canonical);

    const datasetSchema = getOfferListDatasetSchema({
        offerType: props.offerType,
        filters: props.filters,
        region: props.region,
        url: canonicalUrl,
        updateDate: props.updateDate
    });

    if (!datasetSchema) {
        return null;
    }

    // Escape "<" so a "</script>" sequence inside data-sourced text (e.g. region.name) can't break out of the tag.
    const json = JSON.stringify(datasetSchema).replace(/</g, "\\u003c");

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: json}} />;
};
